import { NgModule } from '@angular/core';

import { MasterCompArrayFormClientsActions } from './master-comp-array-form-clients.actions';

@NgModule({
  providers: [
    MasterCompArrayFormClientsActions
  ]
})
export class MasterCompArrayFormClientsActionsModule {}
